"use strict";import{tag as a}from"../custom-tag.js";export function peopleIcon({height:e=16,width:t=16,hidden:l=!1,title:r="People"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <g fill="currentColor">
        <path
          d="M12.038 11.363a4.854 4.854 0 0 1-.316-7.462 3.371 3.371 0 1 0-4.884 4.196c-2.857.702-4.963 3.033-4.963 5.8 0 .731.387 1.756 2.229 2.49.803.298 1.639.5 2.49.598a8.17 8.17 0 0 1 5.443-5.622"
        />
        <path
          d="M15 10.875a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75m-.001 1.501c-3.928 0-7.124 2.85-7.124 6.354 0 .767.407 1.843 2.345 2.614 1.533.548 3.153.813 4.78.78 3.547 0 7.125-1.049 7.125-3.395 0-3.502-3.197-6.353-7.126-6.353"
        />
      </g>
    </svg>
  `}
//# sourceMappingURL=people.js.map
